/*
 * @Author: liuYingBing
 * @Date: 2024-07-10 14:03:14
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-08-06 17:01:40
 * @FilePath: /fushigi/src/axios/axios.ts
 * @Description:
 */
import axios, { AxiosInstance } from 'axios'
import { AXIOS } from '@/types/types'
axios.defaults.withCredentials = true

export default class VAxios {
  private axios: AxiosInstance
  private readonly options: any

  constructor(options: any) {
    this.options = options
    this.axios = axios.create(options)
    this.setupInterceptors()
  }

  private matchUri(config: AXIOS.CreateAxiosOptions) {
    const { data, params } = config
    // if (config.url?.includes('http:')) return config
    config.url = config.url!.replace(/\:\w+/g, (a) => {
      const key = a.slice(1)
      const val = (data || params)[key]
      params && delete config?.params[key]
      data && delete config?.data[key]
      return val
    })

    return config
  }

  private setupInterceptors() {
    const { interceptor } = this.options
    if (!interceptor) return

    const { requestInterceptors, responseInterceptors, responseInterceptorsCatch } = interceptor

    this.axios.interceptors.request.use(requestInterceptors)
    this.axios.interceptors.response.use(responseInterceptors, responseInterceptorsCatch)
  }

  public request<T>(config: any, options?: AXIOS.RequestOptions): Promise<T> {
    config = this.matchUri(config)
    const { requestOptions, interceptor } = this.options
    const opt = { ...requestOptions, ...options }
    config.requestOptions = opt

    const { beforeRequest } = interceptor || {}
    beforeRequest && beforeRequest(config, opt)
    return new Promise((resolve, reject) => {
      this.axios
        .request(config)
        .then((res) => {
          resolve(res.data)
        })
        .catch(reject)
    })
  }
}
